import { memo } from "react";
import styled from "@emotion/styled";

const Checkbox = styled.span<{ checked?: boolean }>`
    width: 12px;
    height: 12px;
    border: 1px solid #999;
    margin: 0 5px 0 0;
    vertical-align: middle;
    background-color: #fff;
    display: inline-block;
    position: relative;

    ${props =>
        props.checked &&
        `
        background-color: #000;
        border-color: #000;

        &:after {
            content: "";
            height: 8px;
            width: 4px;
            border: 1px solid grey;
            border-color: transparent white white transparent;
            transform: rotate(45deg);
            position: absolute;
            top: -2px;
            left: 2px;
        }
    `}
`;

export default memo(Checkbox);
